import { useEffect } from "react";
import jwt_decode from "jwt-decode";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

interface JWTPayload {
  exp: number;
  sub: string;
  email: string;
}



const INACTIVITY_LIMIT = 15 * 60 * 1000;
const CHECK_INTERVAL = 2 * 60 * 1000;


export default function useTokenVerifier() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokens = async () => {
      const now = Date.now();
      const lastActivity = parseInt(localStorage.getItem("lastActivity") || "0", 10);
      const nowSeconds = now / 1000;

      const accessToken = localStorage.getItem("access_token");
      const refreshToken = localStorage.getItem("refresh_token");
      const secondToken = localStorage.getItem("secondAuthToken");

      const userIsInactive = now - lastActivity > INACTIVITY_LIMIT;


      if (accessToken && refreshToken) {
        try {
          const decoded = jwt_decode<JWTPayload>(accessToken);
          if (decoded.exp < nowSeconds) {
            if (userIsInactive) {
              logout();
              toast.info("Votre session a expiré!");
              navigate("/login");
              return;
            } else {

              const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/refresh`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ refresh_token: refreshToken }),
              });

              if (res.ok) {
                const data = await res.json();
                localStorage.setItem("access_token", data.access_token);

              } else if (res.status === 401 || res.status === 403) {
                logout();
                navigate("/login");
              }
              else {
                console.error("Erreur inattendue lors du refresh token");
              }
              return;
            }
          }
        } catch {
          logout();
          navigate("/login");
          return;
        }
      }

      if (secondToken) {
        try {
          const decoded = jwt_decode<JWTPayload>(secondToken);
          if (decoded.exp < nowSeconds) {
            localStorage.removeItem("secondAuthToken");
            toast.info("Veuillez revérifier votre identité !");
            navigate("/verify-code");
            return;
          }
        } catch {
          localStorage.removeItem("secondAuthToken");
          navigate("/verify-code");
          return;
        }
      }
    };

    checkTokens();
    const interval = setInterval(checkTokens, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);
}
